// extracted by mini-css-extract-plugin
module.exports = {"loadingIndicator":"LoadingIndicator_loadingIndicator__3zrh2","spinner":"LoadingIndicator_spinner__1nYfy"};